/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_OverlineInputs */

const en_mk_how_overline = /** @type {(inputs: Mk_How_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HOW IT WORKS`)
};

const id_mk_how_overline = /** @type {(inputs: Mk_How_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CARA KERJA`)
};

/**
* | output |
* | --- |
* | "HOW IT WORKS" |
*
* @param {Mk_How_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_overline = /** @type {((inputs?: Mk_How_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_overline(inputs)
	return en_mk_how_overline(inputs)
});